import { Box, HStack, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

// Hand-rolls Chakra v3's `Status` component (absent in v2); replace with `<Status.Root>` on the v3 migration.
export const saveStateColour = {
  saved: 'green.500',
  saving: 'blue.500',
  unsaved: 'gray.400',
} as const;

export function SaveStateIndicator({
  colour,
  label,
  'data-testid': dataTestId,
}: {
  colour: string;
  label: ReactNode;
  'data-testid'?: string;
}) {
  return (
    <HStack spacing="2" color="fg.muted" flexShrink={0} data-testid={dataTestId}>
      <Box boxSize="2" borderRadius="full" bg={colour} flexShrink={0} />
      <Text fontSize="sm" whiteSpace="nowrap">
        {label}
      </Text>
    </HStack>
  );
}
